import React from 'react'
import { useFormContext } from 'react-hook-form'
import { FormattedMessage } from 'react-intl'

import {
  HouseStudyDayGlobalDto,
  SeasonEnum,
} from '../../../../../../../../../../../lib/graphql'
import { TTCLabel } from '../../../../../../../../../../atoms'
import { ControlledTextField } from '../../../../../../../../../../forms'
import PriceSeasonColorTag from '../../../../../../../../shared/components/seasonal-busyness-calendar/components/tag/price-season-color-tag/PriceSeasonColorTag'
import { formatMoney } from '../../../../../../../../shared/utils/format/format-money/format-money'
import { HouseStudyDayGlobalFieldProps } from '../../../../form-container/HouseStudyDayGlobalFormContainer'

export const HouseStudyDayGlobalSeasonalPriceField = ({
  control,
  currencyArea,
  isFieldDisabled,
  name,
}: HouseStudyDayGlobalFieldProps & {
  name: 'highPrice' | 'lowPrice' | 'mediumPrice'
}) => {
  const fieldProps = {
    disabled: isFieldDisabled,
    control,
    type: 'number',
    inline: true,
    rules: {},
    placeholder: formatMoney({ value: 0, currency: currencyArea.currency }),
  }

  const { setValue } = useFormContext<HouseStudyDayGlobalDto>()

  return (
    <>
      <ControlledTextField
        {...fieldProps}
        name={`options.seasonalPrices.0.${name}`}
        formatValue={(value) =>
          formatMoney({ value, currency: currencyArea.currency })
        }
        placeholder={formatMoney({ value: 0, currency: currencyArea.currency })}
        onReset={() =>
          setValue(`options.seasonalPrices.0.${name}`, null, {
            shouldDirty: true,
          })
        }
        label={
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <PriceSeasonColorTag
              season={
                name === 'highPrice'
                  ? SeasonEnum.HIGH
                  : name === 'lowPrice'
                    ? SeasonEnum.LOW
                    : SeasonEnum.MEDIUM
              }
            />

            <div>
              {name === 'highPrice' ? (
                <FormattedMessage
                  id='ui.HouseStudyDayGlobalFormFields.options.seasonalPrices.0.highPrice'
                  defaultMessage='Prix <bold>par personne du séjour à la journée</bold> haute saison'
                  values={{ bold: (content) => <b>{content}</b> }}
                />
              ) : name === 'lowPrice' ? (
                <FormattedMessage
                  id='ui.HouseStudyDayGlobalFormFields.options.seasonalPrices.0.lowPrice'
                  defaultMessage='Prix <bold>par personne du séjour à la journée</bold> basse saison'
                  values={{ bold: (content) => <b>{content}</b> }}
                />
              ) : (
                <FormattedMessage
                  id='ui.HouseStudyDayGlobalFormFields.options.seasonalPrices.0.mediumPrice'
                  defaultMessage='Prix <bold>par personne du séjour à la journée</bold> moyenne saison'
                  values={{ bold: (content) => <b>{content}</b> }}
                />
              )}

              <span style={{ marginLeft: 5 }}>
                <TTCLabel />
              </span>
            </div>
          </div>
        }
      />
    </>
  )
}
